// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-end {
  border-end-end-radius: 50px;
  border-start-end-radius: 50px;
}

.button-start {
  border-end-start-radius: 3rem;
  border-start-start-radius: 3rem;
}

.icon2 {
  width: 1rem;
}

.game-bar {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  z-index: 2;
  min-width: 20rem;
  height: 2.5rem;
  background: var(--color-light-blue);
  border-radius: 5rem;
}
.game-bar .btn-group {
  background: var(--color-light-blue);
  width: 100%;
  border: none;
  color: var(--color-primary-blue);
  height: 2.5rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
}

.flex-container {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.flex-container .gm-flex-col {
  flex: auto;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  position: relative;
}
.flex-container .gm-flex-col .gm-flex-75 {
  flex: 75%;
}
.flex-container .gm-flex-col .gm-flex-50 {
  flex: 50%;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .gm-flex-25 {
  flex: 25%;
}
.flex-container .gm-flex-col .iconBold {
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconHand {
  margin: 0;
  width: 1.542rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconStar {
  width: 1.208rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .iconFlag {
  width: 1.333rem;
  display: flex;
  justify-content: center;
}
.flex-container .gm-flex-col .icon {
  width: 1rem;
}
.flex-container .gm-flex-col .prev-action-points {
  position: absolute;
  right: 16%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-alliance-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-white);
  display: none;
  background-color: var(--color-secondary-blue);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-council-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .prev-country-points {
  position: absolute;
  right: 10%;
  font-size: 0.667rem;
  color: var(--color-primary-blue);
  display: none;
  background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);
  border-radius: 24px;
  width: 2.208rem;
  height: 1.292rem;
  text-align: center;
  padding-top: 0.15rem;
}
.flex-container .gm-flex-col .fs-28 {
  font-size: 1.167rem;
}
.flex-container .gm-flex-col .fs-24 {
  font-size: 1rem;
}
.flex-container .gm-flex-col .fs-20 {
  font-size: 0.833rem;
}
.flex-container .gm-flex-col:not(:last-child) {
  border-right: 0.125rem solid rgba(51, 102, 153, 0.25);
}

ion-content {
  --background: transparent;
}

.eu-council-game-container {
  position: absolute;
  top: 0;
  z-index: 1;
}

.actions-container {
  position: absolute;
  left: -9rem;
  display: flex;
  flex-direction: column;
  padding: 0.667rem;
  min-width: 7.333rem;
  background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  border-radius: 0.333rem;
  z-index: 4;
}
.actions-container .accept {
  --background: var(--color-primary-blue);
  --border-color: var(--color-primary-blue);
  font-size: 0.75rem;
  line-height: 1rem;
  color: white;
  font-weight: bold;
  min-width: 6rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
}
.actions-container .offer {
  --background: var(--color-primary-blue);
  --border-color: var(--color-primary-blue);
  font-size: 0.625rem;
  line-height: 0.833rem;
  color: white;
  font-weight: bold;
  min-width: 6rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
}
.actions-container .refuse {
  --border-color: var(--color-primary-blue);
  color: var(--color-primary-blue);
  font-weight: bold;
  min-width: 6rem;
  height: 1.667rem;
  min-height: 1.667rem;
  --min-height: 1.667rem;
  font-size: 0.625rem;
  line-height: 0.833rem;
}

.top-row {
  margin-top: 1.167rem;
  margin-bottom: 0.417rem;
}
.top-row .title {
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--color-white);
}
.top-row .title-bold {
  font-weight: bold;
}

.avatar-col {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 20%;
}
.avatar-col .avatar-box {
  position: relative;
  height: 11rem;
  display: flex;
  justify-content: center;
  width: 5rem;
}
.avatar-col .avatar-box .avatar {
  width: 6rem;
  position: absolute;
  z-index: 2;
  margin-left: 1rem;
}
.avatar-col .avatar-box .avatar svg {
  width: 100%;
}
.avatar-col .avatar-box .floor-box {
  position: absolute;
  width: 6rem;
  bottom: 0;
}
.avatar-col .check-here {
  position: absolute;
  bottom: 1rem;
  padding: 1rem;
}
.avatar-col .check-here .text {
  color: var(--color-yellow-bookmark);
  font-size: 0.75rem;
  line-height: 1rem;
}
.avatar-col .check-here .yellow-arrow .yellow-arrow-icon {
  position: absolute;
  top: -1rem;
  right: 2rem;
  width: 1rem;
  height: 1.667rem;
  --animate-duration: 1s;
}

.bilateral-modal-div {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 51, 153, 0.6);
  z-index: 5;
}
.bilateral-modal-div .bilateral-modal-extra {
  color: var(--color-primary-blue);
  width: 11rem;
  padding: 1rem;
  z-index: 1000;
  font-size: 0.75rem;
  background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 0.333rem;
  margin-right: -1rem;
}
.bilateral-modal-div .bilateral-modal-extra .title {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: bold;
  color: var(--color-primary-blue);
}
.bilateral-modal-div .bilateral-modal-extra ul {
  padding-left: 1rem;
  font-size: 0.667rem;
  font-weight: 600;
  line-height: 1rem;
  letter-spacing: 0;
}
.bilateral-modal-div .bilateral-modal-extra ul li:not(:last-child) {
  margin-bottom: 1rem;
}
.bilateral-modal-div .bilateral-modal {
  z-index: 100;
  background: white;
  color: black;
  width: 27.625rem;
  height: 14.667rem;
  background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  padding: 1rem;
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);
  border-radius: 0.667rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.bilateral-modal-div .bilateral-modal.extra-open {
  margin-right: 11rem;
}
.bilateral-modal-div .bilateral-modal .title {
  margin-top: 0.875rem;
  font-size: 1.167rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1.333rem;
  color: var(--color-primary-blue);
  margin-bottom: 0.792rem;
}
.bilateral-modal-div .bilateral-modal .body {
  color: #404953;
  font-size: 0.833rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.333rem;
}
.bilateral-modal-div .bilateral-modal .button {
  height: 2.042rem;
  min-height: 2.042rem;
  --min-height: 2.042rem;
  min-width: 6.333rem;
  color: var(--color-primary-blue);
  --border-color: var(--color-primary-blue);
  font-size: 0.75rem;
  line-height: 1rem;
}
.bilateral-modal-div .bilateral-modal .red_line_box {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.bilateral-modal-div .bilateral-modal .red_line_box .tag {
  color: var(--color-negotiable-green);
  font-size: 0.583rem;
  font-weight: 600;
  letter-spacing: 0;
  height: fit-content;
  line-height: 1rem;
  border: 0.083rem solid var(--color-negotiable-light-green);
  border-radius: 20px;
  background-color: var(--color-white);
  padding: 0 0.417rem;
  white-space: nowrap;
  display: inline-block;
}
.bilateral-modal-div .bilateral-modal .red_line_box .tag.red_line {
  border: 0.083rem solid var(--color-red_line-red);
  color: var(--color-red_line-red);
}
.bilateral-modal-div .bilateral-modal .buttons-container {
  display: flex;
}
.bilateral-modal-div .bilateral-modal .position {
  padding-left: 1rem;
  padding-right: 1rem;
  height: 2.125rem;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0, linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%, linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0, linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%, linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0, linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0, linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%, linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%;
  background-repeat: no-repeat;
  background-size: 0.417rem 0.417rem;
}
.bilateral-modal-div .bilateral-modal .position .text {
  height: auto;
  width: 100%;
  font-size: 0.833rem;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
  text-overflow: ellipsis;
}

.container {
  display: flex;
  width: 100%;
  justify-content: center;
}
.container .flip-card {
  background-color: transparent;
  -o-perspective: 1000px;
  perspective: 1000px;
  width: 14.667rem;
  height: 7rem;
}
.container .flip-card .flip-card-inner {
  width: 100%;
  height: 100%;
  transition: 0.6s;
  -webkit-transition: 0.6s;
  -moz-transition: 0.6s;
  -o-transition: 0.6s;
  -ms-transition: 0.6s;
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -o-transform-style: preserve-3d;
  -ms-transform-style: preserve-3d;
  position: relative;
}
.container .flip-card.zIndex1 .flip-card-inner {
  transform: rotateY(180deg);
}
.container .flip-card .front, .container .flip-card .back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.container .flip-card .front {
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}
.container .flip-card .back {
  transform: rotateY(180deg);
}
.container .flex .dimension-container:not(:last-child) .dimension-line:not(:last-child) {
  height: 1px;
  background: rgba(255, 255, 255, 0.4);
  width: 100%;
  position: absolute;
  bottom: -0.5rem;
}
.container .dimension-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}
.container .dimension-container .background-yellow-icons {
  display: none;
}
.container .dimension-container.opacity-40 {
  opacity: 0.4;
  pointer-events: none;
}
.container .dimension-container.background-yellow {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: 0 0.333rem 0 0 rgba(0, 0, 0, 0.32);
  padding: 0.167rem;
  border-radius: 0.4rem;
}
.container .dimension-container.background-yellow .background-yellow-icons {
  display: block;
  position: absolute;
  text-align: center;
}
.container .dimension-container.background-yellow .background-yellow-icons .blue-arrow {
  width: 100%;
  text-align: center;
}
.container .dimension-container.background-yellow .background-yellow-icons .blue-arrow .icon {
  width: 0.667rem;
  height: 1.333rem;
}
.container .dimension-container.background-yellow .background-yellow-icons .bullet-flag .bullet-flag-icon {
  width: 0.667rem;
  height: 0.5rem;
}
.container .dimension-container.background-yellow .background-yellow-icons .bullet-flag .bullet-flag-text {
  margin-left: 0.2rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-red_line-red);
}
.container .dimension-container.background-yellow .background-yellow-icons .star-ico .star-ico-icon {
  width: 0.708rem;
  height: 0.708rem;
}
.container .dimension-container.background-yellow .background-yellow-icons .star-ico .star-ico-text {
  margin-left: 0.2rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-primary-blue);
}
.container .dimension-container.background-yellow .background-yellow-icons .action .action-icon {
  width: 0.708rem;
  height: 0.708rem;
}
.container .dimension-container.background-yellow .background-yellow-icons .action .action-text {
  margin-left: 0.2rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-primary-blue);
}
.container .dimension-container.marBottom:not(:last-child) {
  margin-bottom: 1rem;
}
.container .dimension-container .box {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 14.667rem;
  border-radius: 0.333rem;
  color: var(--color-primary-blue);
  height: 7rem;
  background-color: #CFE7ED;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
  padding: 0.2rem;
}
.container .dimension-container .box.tradeOff {
  border: 0.167rem solid #FFD924;
}
.container .dimension-container .box.action {
  transform: translate(-0.417rem, -0.333rem);
  box-shadow: 0.333rem 0.333rem 0 0 rgba(0, 0, 0, 0.32);
}
.container .dimension-container .box.action.left {
  transform: translate(0.417rem, -0.333rem);
  box-shadow: -0.333rem 0.333rem 0 0 rgba(0, 0, 0, 0.32);
}
.container .dimension-container .box.action.left:after {
  position: absolute;
  top: 40%;
  right: -1.358rem;
  background-image: url("/assets/negotiation/arrow-yellow.svg");
  background-size: 1rem 2rem;
  content: "";
  z-index: 10;
  width: 1rem;
  height: 2rem;
  display: inline-block;
}
.container .dimension-container .box.action.left.incoming:after {
  transform: rotate(180deg);
}
.container .dimension-container .box.handshake-allied {
  transform: translate(-0.667rem, -0.333rem);
  box-shadow: 0.333rem 0.333rem 0 0 rgba(0, 0, 0, 0.32);
  z-index: 1;
}
.container .dimension-container .box.handshake-allied.left {
  transform: translate(0.667rem, -0.333rem);
  box-shadow: -0.333rem 0.333rem 0 0 rgba(0, 0, 0, 0.32);
  z-index: 2;
}
.container .dimension-container .box.handshake-allied.left:after {
  background-image: url("/assets/negotiation/icon-handshake.svg");
  background-size: 2.667rem 2.667rem;
  content: "";
  position: absolute;
  top: 30%;
  right: -1.9rem;
  z-index: 10;
  width: 2.667rem;
  height: 2.667rem;
  display: inline-block;
}
.container .dimension-container .box .bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
  border-radius: 8px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
.container .dimension-container .box .issue {
  padding: 0.646rem;
  padding-bottom: 0;
  max-height: calc(100% - 1.9rem);
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow-y: auto;
  width: 100%;
}
.container .dimension-container .box .alliance-btn {
  position: relative;
  border-radius: 20px;
  background-color: var(--color-primary-blue);
  color: var(--color-white);
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 0;
  z-index: 1;
  padding: 0.333rem 1.75rem;
}
.container .dimension-container .box .alliance-btn .bg-gradient {
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
}
.container .dimension-container .box.empty {
  cursor: pointer;
}
.container .dimension-container .box div:not(.bg-gradient) {
  z-index: 1;
}
.container .dimension-container .box.left {
  margin-right: 2.667rem;
}
.container .dimension-container .box.confirm {
  align-items: center;
}
.container .dimension-container .box.confirm .text {
  text-align: center;
  line-height: 1rem;
  font-size: 0.667rem;
  font-weight: 500;
  padding-top: 0.517rem;
  padding-left: 0.188rem;
  padding-right: 0.188rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: 3rem;
  overflow-y: auto;
  width: 100%;
}
.container .dimension-container .box.confirm .text-waiting {
  text-align: center;
  line-height: 1rem;
  font-size: 0.833rem;
  font-weight: 500;
  padding-left: 1.188rem;
  padding-right: 1.188rem;
  height: 100%;
  display: flex;
  align-items: center;
}
.container .dimension-container .box.confirm ion-button {
  font-weight: 600;
  letter-spacing: 0;
}
.container .dimension-container .box.confirm .confirm-btn {
  font-size: 0.875rem;
  line-height: 1.167rem;
  min-width: 9rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  margin-top: 0.417rem;
  --padding-top: 0.417rem;
  --padding-bottom: 0.417rem;
}
.container .dimension-container .box.confirm .cancel-btn {
  font-size: 0.667rem;
  line-height: 0.917rem;
  width: 6.417rem;
  height: 1.417rem;
  min-height: 1.417rem;
  --min-height: 1.417rem;
  margin-top: 0.525rem;
  --padding-top: 0.25rem;
  --padding-bottom: 0.25rem;
  margin-bottom: 0.5rem;
}
.container .dimension-container .box .header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.333rem 0.333rem 0 0.667rem;
  font-size: 0.75rem;
  letter-spacing: 0;
  line-height: 1rem;
  align-items: center;
}
.container .dimension-container .box .header .icon {
  cursor: pointer;
}
.container .dimension-container .box .header .icon .bt-info {
  width: 1.333rem;
  height: 1.333rem;
}
.container .dimension-container .box .header .dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.667rem;
  font-weight: bold;
  padding: 0.1rem 0.25rem;
  border-radius: 50%;
}
.container .dimension-container .box.info {
  background-color: #E1F0F3;
}
.container .dimension-container .box.info .header-container {
  display: flex;
  flex-direction: column;
}
.container .dimension-container .box.info .header-container .header {
  padding: 0.333rem 0.333rem 0.313rem 0.333rem;
  display: flex;
  align-items: flex-end;
  text-align: center;
}
.container .dimension-container .box.info .header-container .header .title {
  font-size: 0.5rem;
  line-height: 1rem;
  font-weight: bold;
  flex-grow: 1;
  justify-content: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: 1rem;
  overflow-y: auto;
  width: 100%;
}
.container .dimension-container .box.info .header-container .header-border {
  margin-left: 2.375rem;
  margin-right: 2.417rem;
  border-bottom: 0.083rem solid rgba(0, 51, 153, 0.24);
}
.container .dimension-container .box.info .description {
  padding: 0.646rem;
  height: 100%;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: 4rem;
  overflow-y: auto;
  width: 100%;
}
.container .dimension-container .box .position {
  margin-top: 0.325rem;
  margin-left: 1.292rem;
  margin-right: 1.292rem;
  height: 2.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0, linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%, linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0, linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%, linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0, linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0, linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%, linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%;
  background-repeat: no-repeat;
  background-size: 0.417rem 0.417rem;
}
.container .dimension-container .box .position .text {
  height: auto;
  width: 100%;
  font-size: 0.833rem;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
  text-overflow: ellipsis;
}
.container .dimension-container .box .footer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0 0.625rem 0.325rem 0.667rem;
  flex-grow: 1;
  align-items: flex-end;
}
.container .dimension-container .box .footer .text {
  flex-grow: 1;
  font-size: 0.583rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1rem;
  padding: 0 0.625rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow-y: auto;
  width: 100%;
  height: 1rem;
  margin-right: 0.1rem;
}
.container .dimension-container .box .footer .text .value {
  font-weight: 600;
}
.container .dimension-container .box .footer .tag {
  color: var(--color-negotiable-green);
  font-size: 0.583rem;
  font-weight: 600;
  letter-spacing: 0;
  height: fit-content;
  line-height: 1rem;
  border: 0.083rem solid var(--color-negotiable-light-green);
  border-radius: 20px;
  background-color: var(--color-white);
  padding: 0 0.417rem;
  white-space: nowrap;
}
.container .dimension-container .box .footer .tag.sensitive {
  border: 0.083rem solid var(--color-yellow-bookmark);
  color: var(--color-sensitive-brown);
}
.container .dimension-container .box .footer .tag.negotiable {
  border: 0.083rem solid var(--color-negotiable-light-green);
  color: var(--color-negotiable-green);
}
.container .dimension-container .box .footer .tag.red_line {
  border: 0.083rem solid var(--color-red_line-red);
  color: var(--color-red_line-red);
}
.container .dimension-container .box .footer .tag.exchange {
  font-size: 0.75rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  padding: 0.25rem 1.125rem;
}
.container .dimension-container .box .button {
  cursor: pointer;
}

.close-talk {
  position: absolute;
  bottom: 1rem;
  width: 100%;
}
.close-talk .button {
  font-size: 0.875rem;
  min-width: 9.583rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  line-height: 1.167rem;
  color: var(--color-light-blue);
  --border-color: var(--color-light-blue);
}`, "",{"version":3,"sources":["webpack://./src/app/game/game-bar/game-bar.component.scss","webpack://./src/app/game/bilateral-discussion/bilateral-discussion.page.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,6BAAA;ACCF;;ADEA;EACE,6BAAA;EACA,+BAAA;ACCF;;ADEA;EACE,WAAA;ACCF;;ADEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,mBAAA;ACCF;ADCE;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;ACCJ;;ADKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;ACFF;ADIE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;ACFJ;ADKI;EACE,SAAA;ACHN;ADMI;EACE,SAAA;EACA,aAAA;EACA,uBAAA;ACJN;ADOI;EACE,SAAA;ACLN;ADQI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;ACNN;ADSI;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;ACPN;ADUI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;ACRN;ADWI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;ACTN;ADYI;EACE,WAAA;ACVN;ADaI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACXN;ADcI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACZN;ADeI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACbN;ADgBI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACdN;ADiBI;EACE,mBAAA;ACfN;ADkBI;EACE,eAAA;AChBN;ADmBI;EACE,mBAAA;ACjBN;ADqBE;EACE,qDAAA;ACnBJ;;AArJA;EACE,yBAAA;AAwJF;;AAtJA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AAyJF;;AAtJA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2HAAA;EACA,uBAAA;EACA,UAAA;AAyJF;AAvJE;EACE,uCAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAyJJ;AAtJE;EACE,uCAAA;EACA,yCAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AAwJJ;AArJE;EACE,yCAAA;EACA,gCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;AAuJJ;;AAnJA;EAEE,oBAAA;EACA,uBAAA;AAqJF;AAnJE;EACE,eAAA;EACA,qBAAA;EACA,yBAAA;AAqJJ;AAlJE;EACE,iBAAA;AAoJJ;;AAhJA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;AAmJF;AAjJE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAmJJ;AAjJI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAmJN;AAjJM;EACE,WAAA;AAmJR;AA/II;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAiJN;AA7IE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AA+IJ;AA7II;EACE,mCAAA;EACA,kBAAA;EACA,iBAAA;AA+IN;AA1IM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AA4IR;;AArIA;EACE,kBAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,UAAA;AAwIF;AAtIE;EACE,gCAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,2HAAA;EACA,yCAAA;EACA,uBAAA;EACA,mBAAA;AAwIJ;AAtII;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;AAwIN;AArII;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAuIN;AArIM;EACE,mBAAA;AAuIR;AAlIE;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kGAAA;EACA,aAAA;EACA,yCAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;AAoIJ;AAlII;EACE,mBAAA;AAoIN;AAjII;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gCAAA;EACA,uBAAA;AAmIN;AAhII;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAkIN;AA/HI;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gCAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AAiIN;AA9HI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAgIN;AA9HM;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0DAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAgIR;AA9HQ;EACE,gDAAA;EACA,gCAAA;AAgIV;AA3HI;EACE,aAAA;AA6HN;AA1HI;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,suBAAA;EAQA,4BAAA;EACA,kCAAA;AAoHN;AAlHM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAoHR;;AA9GA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AAiHF;AA9GE;EACE,6BAAA;EAGA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAgHJ;AA9GI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;AAgHN;AA7GI;EAKE,0BAAA;AA+GN;AA5GI;EAIE,2BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA8GN;AA3GI;EACE,UAAA;EACA,mBAAA;EAKA,wBAAA;AA6GN;AA1GI;EAIE,0BAAA;AA4GN;AAtGM;EACE,WAAA;EACA,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAwGR;AAnGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAqGJ;AAnGI;EACE,aAAA;AAqGN;AAlGI;EACE,YAAA;EACA,oBAAA;AAoGN;AAjGI;EACE,yHAAA;EACA,8CAAA;EACA,iBAAA;EACA,qBAAA;AAmGN;AAjGM;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAmGR;AAjGQ;EACE,WAAA;EACA,kBAAA;AAmGV;AAjGU;EACE,eAAA;EACA,gBAAA;AAmGZ;AA9FU;EACE,eAAA;EACA,cAAA;AAgGZ;AA7FU;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AA+FZ;AA1FU;EACE,eAAA;EACA,gBAAA;AA4FZ;AAzFU;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AA2FZ;AAtFU;EACE,eAAA;EACA,gBAAA;AAwFZ;AArFU;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AAuFZ;AAjFI;EACE,mBAAA;AAmFN;AAhFI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gCAAA;EACA,YAAA;EACA,yBAAA;EACA,yCAAA;EACA,eAAA;AAkFN;AA7EM;EACE,8BAAA;AA+ER;AA5EM;EACE,0CAAA;EACA,qDAAA;AA8ER;AA5EQ;EACE,yCAAA;EACA,sDAAA;AA8EV;AA5EU;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,6DAAA;EACA,0BAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA8EZ;AA3EU;EACE,yBAAA;AA6EZ;AAxEM;EACE,0CAAA;EACA,qDAAA;EACA,UAAA;AA0ER;AAxEQ;EACE,yCAAA;EACA,sDAAA;EACA,UAAA;AA0EV;AAxEU;EACE,+DAAA;EACA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AA0EZ;AArEM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,0EAAA;AAuER;AApEM;EACE,iBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;AAsER;AAnEM;EACE,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,yBAAA;AAqER;AAnEQ;EACE,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,4FAAA;AAqEV;AAjEM;EACE,eAAA;AAmER;AAhEM;EACE,UAAA;AAkER;AA/DM;EACE,sBAAA;AAiER;AA9DM;EACE,mBAAA;AAgER;AA9DQ;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAgEV;AA7DQ;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA+DV;AA5DQ;EACE,gBAAA;EACA,iBAAA;AA8DV;AA3DQ;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,0BAAA;AA6DV;AA1DQ;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;AA4DV;AAxDM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AA0DR;AAxDQ;EACE,eAAA;AA0DV;AAxDU;EACE,eAAA;EACA,gBAAA;AA0DZ;AAtDQ;EACE,yHAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AAwDV;AApDM;EACE,yBAAA;AAsDR;AApDQ;EACE,aAAA;EACA,sBAAA;AAsDV;AApDU;EACE,4CAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;AAsDZ;AApDY;EACE,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAsDd;AAlDU;EACE,qBAAA;EACA,sBAAA;EACA,oDAAA;AAoDZ;AAhDQ;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAkDV;AA9CM;EACE,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,suBAAA;EAQA,4BAAA;EACA,kCAAA;AAwCR;AAtCQ;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAwCV;AApCM;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AAsCR;AApCQ;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAsCV;AApCU;EACE,gBAAA;AAsCZ;AAlCQ;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0DAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAoCV;AAlCU;EACE,mDAAA;EACA,mCAAA;AAoCZ;AAjCU;EACE,0DAAA;EACA,oCAAA;AAmCZ;AAhCU;EACE,gDAAA;EACA,gCAAA;AAkCZ;AA/BU;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAiCZ;AA3BM;EACE,eAAA;AA6BR;;AAvBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA0BF;AAxBE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BAAA;EACA,uCAAA;AA0BJ","sourcesContent":[".button-end {\n  border-end-end-radius: 50px;\n  border-start-end-radius: 50px;\n}\n\n.button-start {\n  border-end-start-radius: 3rem;\n  border-start-start-radius: 3rem;\n}\n\n.icon2 {\n  width: 1rem;\n}\n\n.game-bar {\n  position: absolute;\n  bottom: 1rem;\n  left: 1rem;\n  z-index: 2;\n  min-width: 20rem;\n  height: 2.5rem;\n  background: var(--color-light-blue);\n  border-radius: 5rem;\n\n  .btn-group {\n    background: var(--color-light-blue);\n    width: 100%;\n    border: none;\n    color: var(--color-primary-blue);\n    height: 2.5rem;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 1rem;\n    cursor: pointer;\n    padding: 0;\n  }\n}\n\n\n\n.flex-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n\n  .gm-flex-col {\n    flex: auto;\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    padding-left: 0.3rem;\n    padding-right: 0.3rem;\n    position: relative;\n    //cursor: pointer;\n\n    .gm-flex-75 {\n      flex: 75%;\n    }\n\n    .gm-flex-50 {\n      flex: 50%;\n      display: flex;\n      justify-content: center;\n    }\n\n    .gm-flex-25 {\n      flex: 25%;\n    }\n\n    .iconBold {\n      margin-left: 0.5rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconHand {\n      margin: 0;\n      width: 1.542rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconStar {\n      width: 1.208rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .iconFlag {\n      width: 1.333rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    .icon {\n      width: 1rem;\n    }\n\n    .prev-action-points {\n      position: absolute;\n      right: 16%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-alliance-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-white);\n      display: none;\n      background-color: var(--color-secondary-blue);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-council-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .prev-country-points {\n      position: absolute;\n      right: 10%;\n      font-size: 0.667rem;\n      color: var(--color-primary-blue);\n      display: none;\n      background: linear-gradient(180deg, #F9EBAE 0%, #F5DB6D 100%);\n      border-radius: 24px;\n      width: 2.208rem;\n      height: 1.292rem;\n      text-align: center;\n      padding-top: 0.15rem;\n    }\n\n    .fs-28 {\n      font-size: 1.167rem;\n    }\n  \n    .fs-24 {\n      font-size: 1rem;\n    }\n\n    .fs-20 {\n      font-size: 0.833rem;\n    }\n  }\n\n  .gm-flex-col:not(:last-child) {\n    border-right: 0.125rem solid rgba(51, 102, 153, 0.25);\n  }\n}\n","@import './../game-bar/game-bar.component.scss';\n\nion-content {\n  --background: transparent;\n}\n.eu-council-game-container {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n\n.actions-container {\n  position: absolute;\n  left: -9rem;\n  display: flex;\n  flex-direction: column;\n  padding: 0.667rem;\n  min-width: 7.333rem;\n  background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n  border-radius: 0.333rem;\n  z-index: 4;\n\n  .accept {\n    --background: var(--color-primary-blue);\n    --border-color: var(--color-primary-blue);\n    font-size: 0.75rem;\n    line-height: 1rem;\n    color: white;\n    font-weight: bold;\n    min-width: 6rem;\n    height: 1.667rem;\n    min-height: 1.667rem;\n    --min-height: 1.667rem;\n  }\n\n  .offer {\n    --background: var(--color-primary-blue);\n    --border-color: var(--color-primary-blue);\n    font-size: 0.625rem;\n    line-height: 0.833rem;\n    color: white;\n    font-weight: bold;\n    min-width: 6rem;\n    height: 1.667rem;\n    min-height: 1.667rem;\n    --min-height: 1.667rem;\n  }\n\n  .refuse {\n    --border-color: var(--color-primary-blue);\n    color: var(--color-primary-blue);\n    font-weight: bold;\n    min-width: 6rem;\n    height: 1.667rem;\n    min-height: 1.667rem;\n    --min-height: 1.667rem;\n    font-size: 0.625rem;\n    line-height: 0.833rem;\n  }\n}\n\n.top-row {\n\n  margin-top: 1.167rem;\n  margin-bottom: 0.417rem;\n\n  .title {\n    font-size: 1rem;\n    line-height: 1.375rem;\n    color: var(--color-white);\n  }\n\n  .title-bold {\n    font-weight: bold;\n  }\n}\n\n.avatar-col {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  width: 20%;\n\n  .avatar-box {\n    position: relative;\n    height: 11rem;\n    display: flex;\n    justify-content: center;\n    width: 5rem;\n\n    .avatar {\n      width: 6rem;\n      position: absolute;\n      z-index: 2;\n      margin-left: 1rem;\n\n      svg {\n        width: 100%;\n      }\n    }\n\n    .floor-box {\n      position: absolute;\n      width: 6rem;\n      bottom: 0;\n    }\n  }\n\n  .check-here {\n    position: absolute;\n    bottom: 1rem;\n    padding: 1rem;\n\n    .text {\n      color: var(--color-yellow-bookmark);\n      font-size: 0.75rem;\n      line-height: 1rem;\n    }\n\n    .yellow-arrow {\n\n      .yellow-arrow-icon {\n        position: absolute;\n        top: -1rem;\n        right: 2rem;\n        width: 1rem;\n        height: 1.667rem;\n        --animate-duration: 1s;\n      }\n\n    }\n  }\n}\n\n.bilateral-modal-div {\n  position: absolute;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 51, 153, 0.6);\n  z-index: 5;\n\n  .bilateral-modal-extra {\n    color: var(--color-primary-blue);\n    width: 11rem;\n    padding: 1rem;\n    z-index: 1000;\n    font-size: 0.75rem;\n    background: var(--color-yellow-bookmark) linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n    box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.16);\n    border-radius: 0.333rem;\n    margin-right: -1rem;\n\n    .title {\n      font-size: 0.75rem;\n      line-height: 1rem;\n      font-weight: bold;\n      color: var(--color-primary-blue);\n    }\n\n    ul {\n      padding-left: 1rem;\n      font-size: 0.667rem;\n      font-weight: 600;\n      line-height: 1rem;\n      letter-spacing: 0;\n\n      li:not(:last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n  }\n\n  .bilateral-modal {\n    z-index: 100;\n    background: white;\n    color: black;\n    width: 27.625rem;\n    height: 14.667rem;\n    background: var(--color-light-blue) linear-gradient(0deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);\n    padding: 1rem;\n    box-shadow: 0 4px 0 0 rgba(0,0,0,0.16);\n    border-radius: 0.667rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n\n    &.extra-open {\n      margin-right: 11rem;\n    }\n\n    .title {\n      margin-top: 0.875rem;\n      font-size: 1.167rem;\n      font-weight: bold;\n      letter-spacing: 0;\n      line-height: 1.333rem;\n      color: var(--color-primary-blue);\n      margin-bottom: 0.792rem;\n    }\n\n    .body {\n      color: #404953;\n      font-size: 0.833rem;\n      font-weight: 600;\n      letter-spacing: 0;\n      line-height: 1.333rem;\n    }\n\n    .button {\n      height: 2.042rem;\n      min-height: 2.042rem;\n      --min-height: 2.042rem;\n      min-width: 6.333rem;\n      color: var(--color-primary-blue);\n      --border-color: var(--color-primary-blue);\n      font-size: 0.75rem;\n      line-height: 1rem;\n    }\n\n    .red_line_box {\n      padding: 0.5rem;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      align-items: center;\n\n      .tag {\n        color: var(--color-negotiable-green);\n        font-size: 0.583rem;\n        font-weight: 600;\n        letter-spacing: 0;\n        height: fit-content;\n        line-height: 1rem;\n        border: 0.083rem solid var(--color-negotiable-light-green);\n        border-radius: 20px;\n        background-color: var(--color-white);\n        padding: 0 0.417rem;\n        white-space: nowrap;\n        display: inline-block;\n\n        &.red_line {\n          border: 0.083rem solid var(--color-red_line-red);\n          color: var(--color-red_line-red);\n        }\n      }\n    }\n\n    .buttons-container {\n      display: flex;\n    }\n\n    .position {\n      padding-left: 1rem;\n      padding-right: 1rem;\n      height: 2.125rem;\n      margin-bottom: 0.2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      background: linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0,\n      linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%,\n      linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0,\n      linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%,\n      linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0,\n      linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0,\n      linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%,\n      linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%;\n      background-repeat: no-repeat;\n      background-size: 0.417rem 0.417rem;\n\n      .text {\n        height: auto;\n        width: 100%;\n        font-size: 0.833rem;\n        font-weight: bold;\n        letter-spacing: 0;\n        text-align: center;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n\n.container {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n\n\n  .flip-card {\n    background-color: transparent;\n    -webkit-perspective: 1000px;\n    -moz-perspective: 1000px;\n    -o-perspective: 1000px;\n    perspective: 1000px;\n    width: 14.667rem;\n    height: 7rem;\n\n    .flip-card-inner {\n      width: 100%;\n      height: 100%;\n      transition: 0.6s;\n      -webkit-transition: 0.6s;\n      -moz-transition: 0.6s;\n      -o-transition: 0.6s;\n      -ms-transition: 0.6s;\n      transform-style: preserve-3d;\n      -webkit-transform-style: preserve-3d;\n      -moz-transform-style: preserve-3d;\n      -o-transform-style: preserve-3d;\n      -ms-transform-style: preserve-3d;\n      position: relative;\n    }\n\n    &.zIndex1 .flip-card-inner {\n      -webkit-transform: rotateY(180deg);\n      -moz-transform: rotateY(180deg);\n      -o-transform: rotateY(180deg);\n      -ms-transform: rotateY(180deg);\n      transform: rotateY(180deg);\n    }\n\n    .front, .back {\n      -webkit-backface-visibility: hidden;\n      -moz-backface-visibility: hidden;\n      -o-backface-visibility: hidden;\n      backface-visibility: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n\n    .front {\n      z-index: 2;\n      /* for firefox 31 */\n      -webkit-transform: rotateY(0deg);\n      -moz-transform: rotateY(0deg);\n      -o-transform: rotateY(0deg);\n      -ms-transform: rotateY(0deg);\n      transform: rotateY(0deg);\n    }\n\n    .back {\n      -webkit-transform: rotateY(180deg);\n      -moz-transform: rotateY(180deg);\n      -o-transform: rotateY(180deg);\n      transform: rotateY(180deg);\n    }\n  }\n\n  .flex {\n    .dimension-container:not(:last-child) {\n      .dimension-line:not(:last-child) {\n        height: 1px;\n        background: rgba(255, 255, 255, 0.4);\n        width: 100%;\n        position: absolute;\n        bottom: -0.5rem;\n      }\n    }\n  }\n\n  .dimension-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    position: relative;\n\n    .background-yellow-icons {\n      display: none;\n    }\n\n    &.opacity-40 {\n      opacity: 0.4;\n      pointer-events: none;\n    }\n\n    &.background-yellow {\n      background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n      box-shadow: 0 0.333rem 0 0 rgb(0 0 0 / 32%);\n      padding: 0.167rem;\n      border-radius: 0.4rem;\n\n      .background-yellow-icons {\n        display: block;\n        position: absolute;\n        text-align: center;\n\n        .blue-arrow {\n          width: 100%;\n          text-align: center;\n\n          .icon {\n            width: 0.667rem;\n            height: 1.333rem;\n          }\n        }\n\n        .bullet-flag {\n          .bullet-flag-icon {\n            width: 0.667rem;\n            height: 0.5rem;\n          }\n\n          .bullet-flag-text {\n            margin-left: 0.2rem;\n            font-size: 0.75rem;\n            line-height: 1rem;\n            color: var(--color-red_line-red);\n          }\n        }\n\n        .star-ico {\n          .star-ico-icon {\n            width: 0.708rem;\n            height: 0.708rem;\n          }\n\n          .star-ico-text {\n            margin-left: 0.2rem;\n            font-size: 0.75rem;\n            line-height: 1rem;\n            color: var(--color-primary-blue);\n          }\n        }\n\n        .action {\n          .action-icon {\n            width: 0.708rem;\n            height: 0.708rem;\n          }\n\n          .action-text {\n            margin-left: 0.2rem;\n            font-size: 0.75rem;\n            line-height: 1rem;\n            color: var(--color-primary-blue);\n          }\n        }\n      }\n    }\n\n    &.marBottom:not(:last-child) {\n      margin-bottom: 1rem;\n    }\n\n    .box {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      width: 14.667rem;\n      border-radius: 0.333rem;\n      color: var(--color-primary-blue);\n      height: 7rem;\n      background-color: #CFE7ED;\n      box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n      padding: 0.2rem;\n      // visibility: hidden;\n      // &.visibile {\n      //   visibility: visible;\n      // }\n      &.tradeOff {\n        border: 0.167rem solid #FFD924;\n      }\n\n      &.action {\n        transform: translate(-0.417rem, -0.333rem);\n        box-shadow: 0.333rem 0.333rem 0 0 rgb(0 0 0 / 32%);\n\n        &.left {\n          transform: translate(0.417rem, -0.333rem);\n          box-shadow: -0.333rem 0.333rem 0 0 rgb(0 0 0 / 32%);\n\n          &:after {\n            position: absolute;\n            top: 40%;\n            right: -1.358rem;\n            background-image: url('/assets/negotiation/arrow-yellow.svg');\n            background-size: 1rem 2rem;\n            content: \"\";\n            z-index: 10;\n            width: 1rem;\n            height: 2rem;\n            display: inline-block;\n          }\n\n          &.incoming:after {\n            transform: rotate(180deg);\n          }\n        }\n      }\n\n      &.handshake-allied {\n        transform: translate(-0.667rem, -0.333rem);\n        box-shadow: 0.333rem 0.333rem 0 0 rgb(0 0 0 / 32%);\n        z-index: 1;\n\n        &.left {\n          transform: translate(0.667rem, -0.333rem);\n          box-shadow: -0.333rem 0.333rem 0 0 rgb(0 0 0 / 32%);\n          z-index: 2;\n\n          &:after {\n            background-image: url('/assets/negotiation/icon-handshake.svg');\n            background-size: 2.667rem 2.667rem;\n            content: \"\";\n            position: absolute;\n            top: 30%;\n            right: -1.9rem;\n            z-index: 10;\n            width: 2.667rem;\n            height: 2.667rem;\n            display: inline-block;\n          }\n        }\n      }\n\n      .bg-gradient {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        z-index: 0;\n        border-radius: 8px;\n        background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n      }\n\n      .issue {\n        padding: 0.646rem;\n        padding-bottom: 0;\n        max-height: calc(100% - 1.9rem);\n        text-align: center;\n        font-size: 0.75rem;\n        font-weight: 600;\n        line-height: 1rem;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow-y: auto;\n        width: 100%;\n      }\n\n      .alliance-btn {\n        position: relative;\n        border-radius: 20px;\n        background-color: var(--color-primary-blue);\n        color: var(--color-white);\n        font-size: 0.75rem;\n        font-weight: bold;\n        letter-spacing: 0;\n        z-index: 1;\n        padding: 0.333rem 1.75rem;\n\n        .bg-gradient {\n          border-radius: 20px;\n          position: absolute;\n          top: 0;\n          left: 0;\n          z-index: 0;\n          height: 100%;\n          width: 100%;\n          background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n        }\n      }\n\n      &.empty {\n        cursor: pointer;\n      }\n\n      div:not(.bg-gradient) {\n        z-index: 1;\n      }\n\n      &.left {\n        margin-right: 2.667rem;\n      }\n\n      &.confirm {\n        align-items: center;\n\n        .text {\n          text-align: center;\n          line-height: 1rem;\n          font-size: 0.667rem;\n          font-weight: 500;\n          padding-top: 0.517rem;\n          padding-left: 0.188rem;\n          padding-right: 0.188rem;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          max-height: 3rem;\n          overflow-y: auto;\n          width: 100%;\n        }\n\n        .text-waiting {\n          text-align: center;\n          line-height: 1rem;\n          font-size: 0.833rem;\n          font-weight: 500;\n          padding-left: 1.188rem;\n          padding-right: 1.188rem;\n          height: 100%;\n          display: flex;\n          align-items: center;\n        }\n\n        ion-button {\n          font-weight: 600;\n          letter-spacing: 0;\n        }\n\n        .confirm-btn {\n          font-size: 0.875rem;\n          line-height: 1.167rem;\n          min-width: 9rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n          margin-top: 0.417rem;\n          --padding-top: 0.417rem;\n          --padding-bottom: 0.417rem;\n        }\n\n        .cancel-btn {\n          font-size: 0.667rem;\n          line-height: 0.917rem;\n          width: 6.417rem;\n          height: 1.417rem;\n          min-height: 1.417rem;\n          --min-height: 1.417rem;\n          margin-top: 0.525rem;\n          --padding-top: 0.25rem;\n          --padding-bottom: 0.25rem;\n          margin-bottom: 0.5rem;\n        }\n      }\n\n      .header {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 0.333rem 0.333rem 0 0.667rem;\n        font-size: 0.75rem;\n        letter-spacing: 0;\n        line-height: 1rem;\n        align-items: center;\n\n        .icon {\n          cursor: pointer;\n\n          .bt-info {\n            width: 1.333rem;\n            height: 1.333rem;\n          }\n        }\n\n        .dimension-number {\n          background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n          font-size: 0.667rem;\n          font-weight: bold;\n          padding: 0.1rem 0.25rem;\n          border-radius: 50%;\n        }\n      }\n\n      &.info {\n        background-color: #E1F0F3;\n\n        .header-container {\n          display: flex;\n          flex-direction: column;\n\n          .header {\n            padding: 0.333rem 0.333rem 0.313rem 0.333rem;\n            display: flex;\n            align-items: flex-end;\n            text-align: center;\n\n            .title {\n              font-size: 0.5rem;\n              line-height: 1rem;\n              font-weight: bold;\n              flex-grow: 1;\n              justify-content: center;\n              display: -webkit-box;\n              -webkit-box-orient: vertical;\n              max-height: 1rem;\n              overflow-y: auto;\n              width: 100%;\n            }\n          }\n\n          .header-border {\n            margin-left: 2.375rem;\n            margin-right: 2.417rem;\n            border-bottom: 0.083rem solid rgba(0, 51, 153, 0.24)\n          }\n        }\n\n        .description {\n          padding: 0.646rem;\n          height: 100%;\n          text-align: center;\n          font-size: 0.75rem;\n          font-weight: 600;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          max-height: 4rem;\n          overflow-y: auto;\n          width: 100%;\n        }\n      }\n\n      .position {\n        margin-top: 0.325rem;\n        margin-left: 1.292rem;\n        margin-right: 1.292rem;\n        height: 2.125rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        background: linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0,\n        linear-gradient(to right, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%,\n        linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0,\n        linear-gradient(to left, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%,\n        linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 0,\n        linear-gradient(to bottom, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 0,\n        linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 0 100%,\n        linear-gradient(to top, var(--color-primary-blue) 0.083rem, transparent 0.083rem) 100% 100%;\n        background-repeat: no-repeat;\n        background-size: 0.417rem 0.417rem;\n\n        .text {\n          height: auto;\n          width: 100%;\n          font-size: 0.833rem;\n          font-weight: bold;\n          letter-spacing: 0;\n          text-align: center;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .footer {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        padding: 0 0.625rem 0.325rem 0.667rem;\n        flex-grow: 1;\n        align-items: flex-end;\n\n        .text {\n          flex-grow: 1;\n          font-size: 0.583rem;\n          font-weight: 400;\n          letter-spacing: 0;\n          line-height: 1rem;\n          padding: 0 0.625rem;\n          display: -webkit-box;\n          -webkit-box-orient: vertical;\n          overflow-y: auto;\n          width: 100%;\n          height: 1rem;\n          margin-right: 0.1rem;\n\n          .value {\n            font-weight: 600;\n          }\n        }\n\n        .tag {\n          color: var(--color-negotiable-green);\n          font-size: 0.583rem;\n          font-weight: 600;\n          letter-spacing: 0;\n          height: fit-content;\n          line-height: 1rem;\n          border: 0.083rem solid var(--color-negotiable-light-green);\n          border-radius: 20px;\n          background-color: var(--color-white);\n          padding: 0 0.417rem;\n          white-space: nowrap;\n\n          &.sensitive {\n            border: 0.083rem solid var(--color-yellow-bookmark);\n            color: var(--color-sensitive-brown);\n          }\n\n          &.negotiable {\n            border: 0.083rem solid var(--color-negotiable-light-green);\n            color: var(--color-negotiable-green);\n          }\n\n          &.red_line {\n            border: 0.083rem solid var(--color-red_line-red);\n            color: var(--color-red_line-red);\n          }\n\n          &.exchange {\n            font-size: 0.75rem;\n            font-weight: bold;\n            letter-spacing: 0;\n            line-height: 1rem;\n            padding: 0.25rem 1.125rem;\n\n          }\n        }\n      }\n\n      .button {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.close-talk {\n  position: absolute;\n  bottom: 1rem;\n  width: 100%;\n\n  .button {\n    font-size: 0.875rem;\n    min-width: 9.583rem;\n    height: 2rem;\n    min-height: 2rem;\n    --min-height: 2rem;\n    line-height: 1.167rem;\n    color: var(--color-light-blue);\n    --border-color: var(--color-light-blue);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
